module.exports = __webpack_public_path__ + "static/logo-sdm-bba9e9df89885ae004e3fe9adaf71c35.png";